import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=22342a59&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
import style0 from "./Test.vue?vue&type=style&index=0&id=22342a59&prod&lang=scss&scoped=true"
import style1 from "./Test.vue?vue&type=style&index=1&id=22342a59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22342a59",
  null
  
)

export default component.exports